import React from 'react'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
import { useFormikContext } from 'formik'
import { CONSTANTS } from 'constants/index'
import { FormikInput, FormikSelect, FormikAutocomplete } from 'components'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  twoColumn: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  inputContainer: {
    width: '47%',
  },
  phoneInput: {
    height: '40px !important',
  },
  selectIcon: {
    marginRight: '7px',
  },
  firmNameContainer: {
    marginBottom: '16px',
  },
})

const ContactInfoFormBody = ({ states, provinces, countries, updateContactInfo, disableCountryField = false }) => {
  const classes = useStyles()
  const currentUser = useSelector(state => state.auth.currentUser)
  const isAccountant = currentUser?.subrole === 'accountant'
  const { values, setFieldValue } = useFormikContext()

  const getPhoneCountryCode = () => {
    if (!isAccountant) return 'us'
    const selectedCountry = values.country
    if (selectedCountry === 124) return 'ca'
    return 'us'
  }

  const getLocationOptions = () => {
    if (!isAccountant) return states
    const selectedCountry = values.country
    if (selectedCountry === 124) return provinces
    return states
  }

  const getLocationLabel = () => {
    if (!isAccountant) return 'State'
    else return 'State / Province'
  }

  const handleCountryChange = event => {
    const newCountry = event.target.value
    updateContactInfo(event)
    // Clear state field and also update the local state
    setFieldValue('state', '')
    // Also update the local contact info to ensure state is cleared there too
    updateContactInfo({ target: { name: 'state', value: '' } })
  }

  const getStateFieldKey = () => {
    if (!isAccountant) return 'state-field'
    return `state-field-${values.country || 'default'}`
  }

  return (
    <>
      <div className={classes.firmNameContainer}>
        <div className={classes.twoColumn}>
          <FormikSelect
            variant="outlined"
            size="small"
            name="country"
            label="Country"
            type="text"
            fullWidth
            options={countries}
            containerClasses={classes.inputContainer}
            disabled={!isAccountant || disableCountryField}
            required={isAccountant}
            handleSelectChange={handleCountryChange}
            //handleChange={handleCountryChange}
          />
          {isAccountant && (
            <FormikInput
              variant="outlined"
              size="small"
              name="firmName"
              label="Firm name"
              type="text"
              fullWidth
              disabled={disableCountryField}
              containerClasses={classes.inputContainer}
              handleChange={updateContactInfo}
            />
          )}
        </div>
      </div>
      <div className={classes.twoColumn}>
        <FormikInput
          variant="outlined"
          size="small"
          name="street"
          label="Address"
          type="text"
          fullWidth
          containerClasses={classes.inputContainer}
          handleChange={updateContactInfo}
        />
        <FormikInput
          variant="outlined"
          size="small"
          name="suite"
          required={false}
          label="Apartment, Suite, PO Box"
          type="text"
          fullWidth
          containerClasses={classes.inputContainer}
          handleChange={updateContactInfo}
        />
      </div>
      <div className={classes.twoColumn}>
        <FormikInput
          variant="outlined"
          size="small"
          name="city"
          label="City"
          type="text"
          fullWidth
          containerClasses={classes.inputContainer}
          handleChange={updateContactInfo}
        />
        <FormikAutocomplete
          key={getStateFieldKey()}
          variant="outlined"
          size="small"
          name="state"
          label={getLocationLabel()}
          type="text"
          fullWidth
          containerClasses={classes.inputContainer}
          options={getLocationOptions()}
          handleChange={updateContactInfo}
          filterOptions={(options, { inputValue }) =>
            getLocationOptions()?.filter(option => option.label.toLowerCase().startsWith(inputValue.toLowerCase()))
          }
        />
      </div>
      <div className={classes.twoColumn}>
        <FormikInput
          variant="outlined"
          size="small"
          name="zip"
          label={isAccountant ? 'Zip Code / Postal Code' : 'Zip Code'}
          type="text"
          fullWidth
          containerClasses={classes.inputContainer}
          handleChange={updateContactInfo}
        />
      </div>
      <div className={classNames(classes.twoColumn, classes.phoneContainer)}>
        <FormikInput
          key={`phone-${values.country}`}
          variant="outlined"
          size="small"
          name="phone"
          label="Mobile phone"
          type={CONSTANTS.INPUT_TYPE.PHONE}
          fullWidth
          containerClasses={classes.inputContainer}
          inputClass={classes.phoneInput}
          country={getPhoneCountryCode()}
          handleChange={updateContactInfo}
        />
        <FormikInput
          key={`optionalPhone-${values.country}`}
          variant="outlined"
          size="small"
          name="optionalPhone"
          label="Work phone"
          type={CONSTANTS.INPUT_TYPE.PHONE}
          required={false}
          fullWidth
          containerClasses={classes.inputContainer}
          inputClass={classes.phoneInput}
          country={getPhoneCountryCode()}
          handleChange={updateContactInfo}
        />
      </div>
    </>
  )
}

export default ContactInfoFormBody
